import {addMethod, string} from 'yup';
import {CountryCode, parsePhoneNumber} from "libphonenumber-js";

addMethod(string, 'phone', function (defaultCountry: CountryCode, errorMessage: string) {
    return this.test('test-phone-number', errorMessage, function (value: string | undefined, context: any) {
        if (typeof value !== "string") {
            // @ts-ignore
            return this.createError({path: this.path, message: errorMessage});
        }
        const phone = parsePhoneNumber(value, defaultCountry);
        if (!phone.isValid()) {
            // @ts-ignore
            return this.createError({path: this.path, message: errorMessage});
        }

        return true;
    });
});
